import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const ContactSearchModal = ({ open, onClose, onSelectContact }) => {
  const [searchParam, setSearchParam] = useState("");
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setSearchParam("");
      setContacts([]);
    }
  }, [open]);

  useEffect(() => {
    if (searchParam.length < 3) {
      setContacts([]);
      // Sem isso o spinner fica preso: se o usuário apagar um caractere antes do
      // debounce disparar, a requisição nunca roda e o finally nunca executa.
      setLoading(false);
      return;
    }

    setLoading(true);
    const abortController = new AbortController();

    const delayDebounceFn = setTimeout(async () => {
      try {
        const { data } = await api.get("/contacts", {
          params: {
            searchParam,
            contactsOnly: true,
            // Busca apenas no cadastro do contato (nome/número/lid/email). Sem
            // isso o backend também varre o corpo das mensagens e qualquer
            // contato que já tenha CITADO a palavra entra no resultado.
            searchScope: "contact",
          },
          signal: abortController.signal,
        });
        setContacts(data.contacts);
      } catch (err) {
        if (err?.code === "ERR_CANCELED") return;
        toastError(err);
      } finally {
        // Requisição abortada significa que outra já está em andamento — desligar
        // o spinner aqui faria ele piscar no meio da busca seguinte.
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      }
    }, 500);

    return () => {
      clearTimeout(delayDebounceFn);
      abortController.abort();
    };
  }, [searchParam]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{i18n.t("contactSearchModal.title")}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label={i18n.t("contactSearchModal.searchLabel")}
          value={searchParam}
          onChange={(e) => setSearchParam(e.target.value)}
          variant="outlined"
          margin="normal"
        />
        {loading ? (
          <CircularProgress />
        ) : (
          <List>
            {contacts.map((contact) => (
              <ListItem
                button
                key={contact.id}
                onClick={() => onSelectContact(contact)}
              >
                <ListItemText
                  primary={contact.name}
                  secondary={contact.number}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ContactSearchModal;